<template>
  <div class="content">
    <h3 ref="pageHeader" :style="{ '--width': widthVar }" class="pageHeader">实训计划列表</h3>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <el-form-item label="组织结构">
          <OrganDialog ref="organDia1" @getSelect="getSelect1" :level="levell" @handleOrganQuery="handleOrganQuery1">
          </OrganDialog>
          <el-input v-model="organLabel" placeholder="请选择组织结构" style="width:320px;" @focus="dialogOpen1"
            @clear="handeleClear1" clearable></el-input>
        </el-form-item>
        <el-form-item label="计划状态">
          <el-select v-model="formInline.status" clearable placeholder="请选择计划状态">
            <el-option v-for="item in $store.state.planStatus" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="审核状态">
          <el-select v-model="formInline.apply_status" clearable placeholder="请选择审核状态">
            <el-option v-for="item in $store.state.applyStatus" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleAdd(()=>{
            dynamicTags=[]
          })">新增实训计划</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="downloadFile">下载实训计划导入模板</el-button>
        </el-form-item>
        <el-form-item>
          <Importt :uploadSectionFile="uploadSectionFile" @refresh="handleQuery" :action="action" :params="params"
            :btnTitle="btnTitle"></Importt>
        </el-form-item>
        <!-- <el-form-item>
          <el-button type="primary" @click="handleExport">{{exportTitle}}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handlePrint">打印</el-button>
        </el-form-item> -->
      </el-form>
    </div>
    <div>
      <custom-table :data="tableData" ref="table" border style="width: 100%">
        <custom-table-column fixed prop="name" label="实训计划名称" min-width="120">
        </custom-table-column>
        <!-- <custom-table-column fixed prop="training_room_name" :label="`${$store.state.themeTitle}室名称`" width="160">
        </custom-table-column> -->
        <!-- <custom-table-column fixed label="审核状态" width="150">
          <template slot-scope="scope">
            <span v-if="scope.row.apply_status=='apply'" style="color:var(--blue);">待审核</span>
            <span v-if="scope.row.apply_status=='pass'" style="color:var(--ligtGreen);">已通过</span>
            <span v-if="scope.row.apply_status=='refuse'" style="color:var(--red);">已拒绝</span>
          </template>
</custom-table-column> -->
        <custom-table-column label="计划状态" width="150" prop="status" label-class-name="planStatus"
          :formatter="format_arr">
        </custom-table-column>
        <custom-table-column prop="structure_1" label="院系" width="160">
        </custom-table-column>
        <custom-table-column prop="major" label="专业" width="160">
        </custom-table-column>
        <custom-table-column prop="term" label="学年学期" width="160">
        </custom-table-column>
        <custom-table-column prop="class_plan_list" label="课程内容" min-width="260">
          <template slot-scope="scope">
            <p v-for="item in scope.row.class_plan_list" :key="item.id">
              {{ `${item.course_name},${item.week}周,${item.sector}节,${item.xq}` }}</p>
          </template>
        </custom-table-column>
        <custom-table-column prop="start_time" label="开始时间" width="180">
        </custom-table-column>
        <custom-table-column prop="end_time" label="结束时间" width="180">
        </custom-table-column>
        <custom-table-column prop="creator_name" label="创建人" width="160">
        </custom-table-column>
        <custom-table-column prop="created_at" label="创建时间" width="180">
        </custom-table-column>
        <custom-table-column prop="desc" label="备注" min-width="280">
        </custom-table-column>
        <custom-table-column fixed="right" label="操作" width="140">
          <template slot-scope="scope">
            <!-- <el-button @click="handleApply(scope.row.id,'pass')" type="text" size="small">通过</el-button>
            <el-button @click="handleApply(scope.row.id,'refuse')" type="text" size="small">拒绝</el-button> -->
            <el-button @click="handleEdit(scope.row)" type="text" size="small">编辑</el-button>
            <el-button @click="handleDelet(scope.row.id)" type="text" size="small">删除</el-button>
          </template>
        </custom-table-column>
      </custom-table>
      <div class="pageLine">
        <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="centerDialogVisible" width="746px">
      <OrganDialog ref="organDia" @getSelect="getSelect" :level="levell" @handleOrganQuery="handleOrganQuery">
      </OrganDialog>
      <el-dialog :close-on-click-modal="false" title="绑定课程" :visible.sync="detailDialogVisible" width="806px"
        append-to-body>
        <div>
          <el-form :inline="true" :model="formInline1" class="demo-form-inline" label-position="left">
            <el-form-item label="课程名称">
              <el-input v-model="formInline1.course_name" placeholder="请输入课程名称"></el-input>
            </el-form-item>
            <!-- <el-form-item label="学期">
              <el-select v-model="formInline1.term" clearable filterable placeholder="请选择学期">
                <el-option v-for="(item,index) in $store.state.termms" :key="index" :label="item.term" :value="item.term"></el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item :label="`${$store.state.themeTitle}室名称`">
              <el-select v-model="formInline1.training_name" clearable filterable
                :placeholder="`请选择${$store.state.themeTitle}室名称`">
                <el-option v-for="item in $store.state.trainRooms" :key="item.id" :label="item.training_name"
                  :value="item.training_name"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="handleQuery1">查询</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="handleBindInfo">确认绑定</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div>
          <custom-table :data="tableData1" border style="width: 100%" @selection-change="handleSelectionChange">
            <custom-table-column type="selection" width="55">
            </custom-table-column>
            <custom-table-column fixed prop="course_name" label="课程名称" width="180">
            </custom-table-column>
            <custom-table-column fixed prop="training_name" :label="`${$store.state.themeTitle}室名称`" width="160">
            </custom-table-column>
            <custom-table-column prop="term" label="学期" width="160">
            </custom-table-column>
            <custom-table-column prop="week" label="周次" width="100">
            </custom-table-column>
            <custom-table-column prop="xq" label="星期" width="100">
            </custom-table-column>
            <custom-table-column prop="sector" label="节次" width="100">
            </custom-table-column>
            <custom-table-column prop="structure_1" label="所属院系" width="180">
            </custom-table-column>
            <custom-table-column prop="structure_2" label="专业" width="180">
            </custom-table-column>
            <custom-table-column prop="class_name" label="班级名称" width="180">
            </custom-table-column>
            <!-- <custom-table-column fixed="right" label="操作" width="80">
            <template slot-scope="scope">
              <el-button @click="handleDelet1(scope.row.id)" type="text" size="small">删除</el-button>
            </template>
          </custom-table-column> -->
          </custom-table>
          <div class="pageLine">
            <PageLine :total='total1' ref="pageChild1" @getList="getList1"></PageLine>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="detailDialogVisible = false">取 消</el-button>
          <!-- <el-button type="primary" @click="deleteTarinRoom">确 定</el-button> -->
        </span>
      </el-dialog>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
        <el-form-item label="实训计划名称" prop="name">
          <el-input v-model="ruleForm.name" placeholder="请输入实训计划名称" style="width:216px;"></el-input>
        </el-form-item>
        <!-- <el-form-item label="学  年" prop="school_year">
          <el-date-picker v-model="ruleForm.school_year" value-format="yyyy" type="year" placeholder="请选择学年" style="width:216px;"></el-date-picker>
        </el-form-item> -->
        <el-form-item label="学年学期" prop="term" @change="handleTremChange">
          <el-select v-model="ruleForm.term" clearable placeholder="请选择学年学期" style="width:216px;">
            <!-- <el-option v-for="item in $store.state.termms" :key="item.value" :label="item.label" :value="item.value"></el-option> -->
            <el-option v-for="(item, index) in $store.state.termms" :key="index" :label="item.term"
              :value="item.term"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item :label="`${$store.state.themeTitle}室`" prop="training_room_no">
          <el-select v-model="ruleForm.training_room_no" style="width:216px;" filterable clearable :placeholder="`请选择${$store.state.themeTitle}室`" @change="handleClassChange">
            <el-option v-for="item in $store.state.trainRooms" :key="item.id" :label="item.training_name" :value="item.training_no"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="开始时间" prop="start_time">
          <el-date-picker type="datetime" placeholder="选择开始时间" value-format="yyyy-MM-dd HH:mm:ss"
            v-model="ruleForm.start_time" style="width:216px;"></el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间" prop="end_time">
          <el-date-picker type="datetime" placeholder="选择结束时间" value-format="yyyy-MM-dd HH:mm:ss"
            v-model="ruleForm.end_time" style="width:216px;"></el-date-picker>
        </el-form-item>
        <el-form-item label="组织结构" prop="major">
          <el-input v-model="selectName" placeholder="请选择院系+专业" style="width:552px;" @focus="dialogOpen"
            @clear="handeleClear" clearable></el-input>
        </el-form-item>
        <!-- <el-form-item label="指导老师" prop="teacher_number">
          <el-select v-model="ruleForm.teacher_number" style="width:216px;" filterable :loading="loading" remote :remote-method="remoteMethod" @change="handleTeacherChange" placeholder="请选择指导教师">
            <el-option v-for="item in users" :key="item.id" :label="item.name" :value="item.id">
              <p>{{ item.name }}</p>
              <p v-if="item.number" class="el-option-tips">工号：{{ item.number }}</p>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="指导老师工号" prop="teacher">
          <el-input :value="ruleForm.teacher_number" :disabled="true" placeholder="请选择指导教师" style="width:216px;"></el-input>
        </el-form-item> -->
        <el-form-item label="备注" prop="desc">
          <el-input type="textarea" v-model="ruleForm.desc" style="width:552px;"></el-input>
        </el-form-item>
        <el-form-item label="课程绑定" prop="class_plan_ids">
          <el-tag :key="tag.id" v-for="tag in dynamicTags" closable :disable-transitions="false"
            @close="handleClose(tag)">
            {{ tag.course_name }},{{ tag.term }},{{ tag.week }}周,{{ tag.sector }}节
          </el-tag>
          <el-button class="button-new-tag" size="small" @click="showDialog">点击绑定</el-button>
        </el-form-item>
        <el-form-item style="margin-top:8px;width:100%;text-align:right;">
          <el-button type="primary" v-if="type == 'add'" @click="submitForm('ruleForm')">确认</el-button>
          <el-button type="primary" v-if="type == 'edit'" @click="submitForm('ruleForm')">编辑</el-button>
          <el-button @click="resetForm('ruleForm')" style="margin-right:24px;">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="提示" :visible.sync="dialogVisible" width="400px">
      <span>是否删除</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleteMethod">确 定</el-button>
      </span>
    </el-dialog>
    <!-- <OrganDialog ref="organDia"></OrganDialog> -->
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
import { mixinOrgan } from '@/assets/js/mixin/organization';
import { mixinImport } from '@/assets/js/mixin/import';
import { mixinFormatter } from '@/assets/js/mixin/formatter';

export default {
  name: 'trainingRoom',
  mixins: [mixinList, mixinOrgan, mixinImport, mixinFormatter],
  data() {
    return {
      classRooms: [],
      institutes: [],
      formInline: {
        status: '',
        apply_status: '',
        training_room_name: '',
      },
      levell: [1, 2],
      selectName: '',
      organLabel: '',
      formInline1: {
        training_name: '',
        status: 'pass',
        structure_1: '',
        structure_2: '',
        course_name: '',
        term: '',
      },
      tableData1: [],
      total1: 0,
      detailDialogVisible: false,
      ruleForm: {
        name: '',
        term: '',
        start_time: '',
        end_time: '',
        structure_1: '',
        major: '',
        desc: '',
        class_plan_ids: '',
      },
      rules: {
        name: [{ required: true, message: '请输入实训计划名称', trigger: 'blur' }],
        // school_year: [{ required: true, message: '请选择学年', trigger: 'change' }],
        term: [{ required: true, message: '请选择学年学期', trigger: 'change' }],
        // structure_1: [{ required: true, message: '请输入所属院系', trigger: 'blur' }],
        // major: [{ required: true, message: '请输入专业', trigger: 'blur' }],
        major: [
          { required: true, message: '请选择院系+专业' },
        ],
        start_time: [{ required: true, message: '请选择开始时间', trigger: 'change' }],
        end_time: [{ required: true, message: '请选择结束时间', trigger: 'change' }],
        class_plan_ids: [{ required: true, message: '请选择课程' , trigger: 'change' }],
        // teacher: [{ required: true, message: '请输入指导教师', trigger: 'blur' }],
        // teacher_number: [{ required: true, message: '请输入指导教师', trigger: 'blur' }],
        // training_room_no: [{ required: true, message: `请选择${this.$store.state.themeTitle}室`, trigger: 'change' }],
        // desc: [{ required: true, message: '请输入备注', trigger: 'blur' }],
      },
      type: 'add',
      tableName: '实训日志',
      loading: false,
      users: [],
      action: '',
      downloadUrl: 'template/实训计划导入模版.xlsx',
      downloadName: '实训计划导入模版.xlsx',
      btnTitle: '导入实训计划数据',
      dynamicTags: [],
      multipleSelection: [],
    };
  },
  created() { },
  mounted() {
    // this.getList();
    this.action = `${this.baseUrlt}api/training_plan/import`;
    this.$store.dispatch('getTarinMent');
    this.$store.dispatch('getTermms');
    
  },
  watch: {
    dynamicTags(val) {
       if (val && val.length) {
        this.ruleForm.class_plan_ids = val
          .map((item) => {
            return item.id;
          })
          .join(',');
      }else{
        this.ruleForm.class_plan_ids = '';
      }
    },
  },
  methods: {
    handleEdit(row, filterArr = ['updated_at', 'deleted_at', 'created_at', 'login_time', 'class_plan_list']) {
       this.dynamicTags =[]
      if (row.structure_1 && row.major) {
        this.selectName = `${row.structure_1}-${row.major}`;
      }
      if (row.class_plan_list && row.class_plan_list.length) {
        this.dynamicTags = row.class_plan_list
      }
      this.type = 'edit';
      this.title = '编辑';
      this.ruleForm = this.$until.delProp(row, filterArr);
      console.log(this.ruleForm);
      this.centerDialogVisible = true;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleBindInfo() {
      this.dynamicTags = this.multipleSelection;
      this.detailDialogVisible = false;
    },
    showDialog() {
      if (!this.ruleForm.term) {
        this.$refs.ruleForm.validateField('term');
        this.$message.warning('请先选择学年学期！');
        return;
      }
      if (!this.ruleForm.major) {
        this.$refs.ruleForm.validateField('major');
        this.$message.warning('请先选择组织结构！');
        return;
      }
      this.formInline1.term = this.ruleForm.term;
      this.formInline1.structure_1 = this.ruleForm.structure_1;
      this.formInline1.structure_2 = this.ruleForm.major;
      this.detailDialogVisible = true;
      if (this.tableData1.length == 0) {
        this.handleQuery1();
      }
    },
    handleClose(tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },
    handleQuery1() {
      this.$nextTick(() => {
        this.$refs.pageChild1.page = 1;
        this.getList1();
      });
    },
    async getList1() {
      let params = this.$until.deleteNullPrototype(this.formInline1);
      params.page = this.$refs.pageChild1.page;
      params.size = this.$refs.pageChild1.size;
      let res = await this.$api.query.getClassPlanList(params);
      if (res.code == 0 && res.data) {
        this.tableData1 = res.data.data;
        this.total1 = res.data.total;
      }
    },
    handleTeacherChange(val) {
      this.ruleForm.teacher = this.$until.getLabelName(this.users, 'number', 'name', val);
      console.log(this.ruleForm);
    },
    handleInstituteChange(e) {
      console.log(e);
      this.ruleForm.institute_name = this.$until.getLabelName(this.institutes, 'isid', 'ismc', e);
    },
    async remoteMethod(query) {
      this.loading = true;
      this.users = [];
      let params = {
        page: 1,
        size: 10,
        name: query,
      };
      // console.log(query)
      // return
      let res = await this.$api.query.getUsersUnLoad(params);
      if (res.code == 0 && res.data) {
        this.users = res.data.data;
        // this.total = res.data.total;
      }
      this.loading = false;

      // this.users = res.data.data;
    },
    async getTarinMent() {
      let res = await this.$api.instance.getTarinMent();
      if (res.code == 0) {
        this.classRooms = res.data;
      }
    },
    handleApply(apply_id, apply_status) {
      let str = '通过';
      if (apply_status == 2) {
        str = '拒绝';
      }
      this.$confirm(`此操作将${str}该实训计划, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.applyStatus(apply_id, apply_status, str);
        })
        .catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消删除',
          // });
        });
    },
    async applyStatus(plan_id, apply_status, str) {
      let params = { plan_id, apply_status };
      let res = await this.$api.update.applyPlanStatus(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          message: `${str}成功!`,
        });
        this.handleQuery();
      }
    },
    handleClassChange(e) {
      // this.ruleForm.room_id = e.id
      this.ruleForm.training_room_name = this.$until.getLabelName(this.$store.state.trainRooms, 'training_no', 'training_name', e);
      this.tableData1 = [];
    },
    handleTremChange(e) {
      this.tableData1 = [];
    },
    handleSet() {
      this.centerDialogVisible = true;
    },
    handleClick() {
      this.centerDialogVisible = true;
    },
    handleBack() {
      this.$message.info('撤销中。。。');
    },
    getOrganList() {
      this.tableData1 = [];
      this.beforeGetOrgan()
    },
    handlePrint() {
      this.$message.info('打印中。。。');
    },
    async deleteMethod() {
      let params = { plan_id: this.delid };
      let res = await this.$api.delet.deletePlanV2(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '删除成功！',
        });
        this.dialogVisible = false;
        this.handleQuery();
      }
    },
    async createMethod() {
      let params = this.$until.deleteNullPrototype(this.ruleForm);
      let res = await this.$api.creat.creatTrainPlanV2(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '提交成功！',
        });
        this.clearState();
        this.dynamicTags = [];
      }
    },
    async updateMethod() {
      let params = this.$until.easyDeepCopy(this.ruleForm);;
      let res = await this.$api.update.updateClassPlanV2(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '编辑成功！',
        });
        this.clearState();
      }
    },
    // resetForm(formName) {
    //   this.$refs[formName].resetFields();
    // },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.type == 'add') {
            this.createMethod();
          } else if (this.type == 'edit') {
            this.updateMethod();
          }
        } else {
          // console.log('error submit!!');
          return false;
        }
      });
    },
    handleQuery() {
      this.beforeQuery()
      this.$refs.pageChild.page = 1;
      this.getList();
    },
    async getList() {
      let params = this.$until.deleteNullPrototype(this.formInline);
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      let res = await this.$api.query.getAdminPlanesV2(params);
      if (res.code == 0 && res.data) {
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}

.el-tag {
  margin-right: 10px;
}

.button-new-tag {
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
</style>
